<template>
  <div
    v-if="!!message"
    class="teh-message__card"
    :data-qa="`teh-message-alert${!!message ? '-show' : ''}`">
    <div class="teh-message__card-content">
      <div
        v-dompurify-html="message"
        class="teh-message__card-col-1"
        data-qa="teh-message-alert-text"/>
      <div class="teh-message__card-col-2">
        <sButton
          data-qa="btn-teh-message-alert-close"
          icon="cancel"
          small
          type="text"
          @click="message=null"/>
      </div>
    </div>
  </div>
</template>
<script>
import { storageMixin } from 'mixins'
import SmarttenderApi from '@/api/smarttenderApi'
const api = new SmarttenderApi()

/**
 * Простое отображение информационного сообщения с бека
 */
export default {
  name: 'teh-message-alert',
  mixins: [storageMixin],
  data() {
    return {
      message: null,
    }
  },
  async created() {
    await api.getSystemAlert()
      .then(async (localHeaders) => {
        this.message = localHeaders
      })
  },
}
</script>
<style scoped lang="scss">
.teh-message {
  &__card {
    transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
    width: 100%;
    color: var(--black-color);
    padding: 16px 16px 16px 36px;
    border-radius: 4px;
    background-color: var(--v-main__light_green-base);
    border-color: var(--v-main__light_green-base);
    text-align: left;
    margin-bottom: 14px;
    &-content {
      display: flex;
      justify-content: space-between;
    }
    &-col-1 {
      margin: auto 0;
      font-size: 14px;
      line-height: 18px;
    }
    &-col-2 {
      display: flex;
    }
  }
}
</style>
